import React from 'react'

import Link from '@Pure/Link'

export const form =
{
	model: 'ShowTheme'.toLowerCase(),
	name: 'ShowTheme'.toLowerCase(),

	form_title: 'Thème de spectacle',

	fields:
	{
		'label':
		{
			label: 'Libellé'
		}
	},

	create_label: 'Créer ce thème',

	get__deleteModalText: function (form_data)
	{
		var output =
		(
			<span>
				<p>
					Êtes vous sûr de vouloir supprimer ce thème&nbsp;?
				</p>

				<div className="u-center">

					<div className="name-in-modal">

						{ form_data['showtheme[label]'] }

					</div>

				</div>
			</span>
		);

		return output;
	},

	get__createdMessage: function (model)
	{
		var output =
		(
			<div className="c-message c-message--green">
				<div className="c-message__content">
					Le nouveau thème <strong> { model.label } </strong> a été créé.
					{ ' ' }
					<Link className="c-link c-link--highlighted c-link--green"
						href={ '/configuration/themes/' + model.id }>
						Voir le thème
					</Link>
				</div>
			</div>
		);

		return output;
	}
};

export const list =
{
	model: 'ShowTheme'.toLowerCase(),
	title: 'Liste des thèmes de spectacle',
	link: '/configuration/themes',
	creation_link: '/configuration/nouveau-theme',
	creation_label: 'Nouveau thème',
	header_map:
	{
		'Libellé': 'label'
	},
	row_link_base: '/configuration/themes/',
	searched_prop: 'label'
};

let config = Object.assign({ }, form);

Object.assign(config, list);

export default config